import React, {Fragment, useState, useEffect, useContext} from "react";
import './LetterboxTab.scss';
import useModalAddLetterboxItem from "root/Modals/AddLetterboxItem/useModalAddLetterboxItem";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import LetterboxTable from "root/Tables/LetterboxTable";
import {LetterBoxFilter} from "root/DataFunctions/Constants";
import {useSetRecoilState} from "recoil";
import {childNameAtom} from "root/recoil/childName";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import LetterboxContext from "root/contexts/LetterboxContext";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxTab = (props) =>
{
    const [data, setData] = useState({isLoading: true, data: []});
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const letterboxContext = useContext( LetterboxContext ) ;

    const globals = useContext(GlobalContext);
    const shouldShowToApprove = doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType)  ;
    const menuDefault = shouldShowToApprove ? LetterBoxFilter.UNAPPROVED : LetterBoxFilter.TO_SEND_ON;
    const letterbox_decision_filter = queryParams.type === undefined ? menuDefault : queryParams.type;

    const [renderAddLetterboxModal, showAddLetterboxModal] = useModalAddLetterboxItem((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    useEffect(() => {
        getData();
    }, [letterbox_decision_filter, props.child_uid]);

    const getData = () =>
    {
        letterboxContext.getMyLetterbox (props.child_uid, letterbox_decision_filter ) ;
    }

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getChildData();
    }, [props.child_uid]);

    const getChildData = () =>{
        if(props.child_uid !== 'all' && props.child_uid !== undefined)
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const clickHandler = (mode, child_uid, letterbox_item_id) =>
    {
        showAddLetterboxModal(mode, child_uid, letterbox_item_id);
    }

    const myLetterboxTable = () => {
        return (
            <Fragment>
                <div className="post-body">
                    <LetterboxTable child_uid={props.child_uid} loading={letterboxContext.isLetterboxLoading} data={letterboxContext.letterboxData} clickHandler={clickHandler}/>
                </div>
            </Fragment>
        )
    }

    return (
        <Fragment>
            { letterboxContext.isLetterboxLoading === false && myLetterboxTable()}
            {renderAddLetterboxModal(props)}
        </Fragment>
    )
}

LetterboxTab.defaultProps = {};

export default LetterboxTab;

